export const generateUrlWithParameters = (url, parameters = {}) => {
    Object.keys(parameters).forEach((key, index) => {
        url += `${index === 0 ? '?' : '&'}${key}=${parameters[key]}`;
    });
    return url;
};
